import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d'; // Import the 3D module
import HighchartsReact from 'highcharts-react-official';

// Initialize 3D support
Highcharts3D(Highcharts);

class CylinderChart extends Component {
  constructor(props) {
    super(props);

    if (typeof HighchartsDrilldown === 'function') {
      HighchartsDrilldown(Highcharts);
    }
  }

  render() {
    const { categories, series } = this.props;
    console.log("series column", categories, series);

    const options = {
      chart: {
        type: 'column',
        height: "50%",
        backgroundColor: 'rgba(0,0,0,0)', // Transparent background
        options3d: {
          enabled: true,  // Enable 3D
          alpha: 0,      // Tilt angle
          beta: 30,       // Rotate angle
          depth: 50,      // Depth of the 3D chart
          viewDistance: 50
        }
      },
      credits: {
        enabled: false // Disable the Highcharts credits
      },
      title: false,
      xAxis: {
        categories: categories,
        labels: {
          style: {
            color: '#217ca3', // Label text color
            fontWeight: 'bold', 
            fontSize: '13px' // Increase the font size here
          }
        },
        title: {
          text: 'Years',
          style: {
            color: '#217ca3', // Label text color
            fontWeight: 'bold', 
            fontSize:"16px" // Label font weight
            // Label font weight
          }
        }
      },
      gridLineWidth: 10, // Increase the width of the grid lines (default is 0)
      gridLineColor: '#cccccc',// Optional: Set grid line color
      yAxis: {
        labels: {
          style: {
            color: '#217ca3', // Label text color
            fontWeight: 'bold', 
            fontSize: '13px' // Increase the font size here
          }
        },
        title: {
          text: 'Number of downloads',
          
          style: {
            color: '#217ca3', // Label text color
            fontWeight: 'bold',
            fontSize:"16px" // Label font weight
          }
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          color: "#217ca3",
          depth: 25,  // Depth of each 3D column
          dataLabels: {
            enabled: false,
          }
        }
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b>', // Displaying the y-value (which corresponds to your series data)
        formatter: function () {
          const value = this.y; 
          const value1 = this.x;
          return `Total number of downloads in the year ${value1} is <b>${value}</b>`;
        }
      },
      series: [
        {
          data: series
        }
      ]
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
  }
}

export default CylinderChart;
